import Config from './config';
import Authentication from './authentication';
import RecursiveIterator from './recursive-iterator';
import UUID from 'uuid';

export default async function (query, variables = {}){
  if (!(query instanceof Function)) {
    throw new Error('Expected query to be a function');
  }
  const token = Authentication.getToken();

  const headers = {};

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
    variables.identity = token;
  }


  const formData = new FormData();

  for(let { node, parent, key } of new RecursiveIterator(variables)) {
    if (!(node instanceof File)) {
      continue;
    }

    const id = `FILE-${UUID.v4()}`;
    formData.append(id, node);
    parent[key] = id;
  }

  const body = query(variables);

  formData.append('query', body.query);

  if (body.variables) {
    formData.append('variables', body.variables);
  }

  if (body.operationName) {
    formData.append('operationName', body.operationName);
  }

  const response = await fetch(`${Config.api.host}${Config.api.path}`, {
    method: 'POST',
    body: formData,
    headers,
    credentials: 'include'
  });

  const result = await response.json();

  if (result.errors || !result.data) {
    const error = new Error(((result.errors || [])[0] || {}).message || 'Unexpected error while invoking endpoing');
    error.errors = result.errors;
    throw error;
  }

  return result.data;
}


// WEBPACK FOOTER //
// ./src/query.js